import { createStorage } from 'unstorage';
import memoryStorageDriver from "unstorage/drivers/memory";

const articleQuantityStorageClient = createStorage({
  driver: memoryStorageDriver()
});

export type ArticleQuantityCacheType = 'currentLocation' | 'none';

const createKey = (articleNumber: string) => `articleQuantity-${articleNumber}`;

interface ArticleQuantityCacheItem {
  articleNumber: string;
  locationQuantities: LocationQuantity[];
}

interface LocationQuantity {
  quantity: number;
  path: string;
}

export async function setArticleQuantityCache(articleNumber: string, amount: number) {
  let item = await articleQuantityStorageClient.getItem<ArticleQuantityCacheItem>(createKey(articleNumber));
  if(item) {
    const locationQuantity = item.locationQuantities.find(x => x.path === document.location.pathname);
    if(locationQuantity) {
      locationQuantity.quantity = amount;
    } else {
      item.locationQuantities.push({
        quantity: amount,
        path: document.location.pathname
      });
    }
  } else {
    item = {
      articleNumber,
      locationQuantities: [
        {path: document.location.pathname, quantity: amount}
      ]
    }
  }

  await articleQuantityStorageClient.setItem<ArticleQuantityCacheItem>(createKey(articleNumber), item);
}

export async function getArticleQuantityCache(articleNumber: string) {
  if(await articleQuantityStorageClient.has(createKey(articleNumber))) {
    const item = await articleQuantityStorageClient.getItem<ArticleQuantityCacheItem>(createKey(articleNumber));

    const location = document.location.pathname;

    if(location) {
      const locationQuantity = item?.locationQuantities.find(x => x.path === location);
      return locationQuantity ? locationQuantity.quantity : 0;
    }
  }

  return 1;
}

export async function clearArticleQuantityCache() {
  await articleQuantityStorageClient.clear();
}